@for (contact of contacts; track trackById($index, contact)) {
<div class="contact-list">
  <div class="contact-list-user">
    <atx-avatar
      size="s"
      [image]="contact.imageLink"
      [fullName]="contact.displayName"
      [connectionStatus]="contact.connectionStatus"
    ></atx-avatar>
    <div class="d-flex flex-column ml-3 contact-list-user_info">
      <span class="name font-weight-medium">{{ contact.displayName }}</span>
      <span class="text-muted ellipsis">
        @if (hyperlinkEmail) {
        <a [href]="'mailto:' + contact.email">
          {{ contact.email }}
        </a>
        } @else {
        {{ contact.email }}
        }
      </span>
    </div>
    @if (contentOnTheRightTemplateRef) {
    <ng-container
      [ngTemplateOutlet]="contentOnTheRightTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: contact }"
    >
    </ng-container>
    }
  </div>
</div>
}
